import { render, staticRenderFns } from "./certList.vue?vue&type=template&id=701699df"
import script from "./certList.vue?vue&type=script&lang=js"
export * from "./certList.vue?vue&type=script&lang=js"
import style0 from "./certList.vue?vue&type=style&index=0&id=701699df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports